export default __webpack_public_path__ + "static/compareItemImg3-669a1132c9b995ba2cb58e4b54cda05c.png";